import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, CardHeader, StatusPill } from "../components/primitives";

const ROLES = ["Chief Compliance Officer","Head of AML","MLRO","Sanctions Officer","Transaction Monitoring Manager","KYC/CDD Manager","Senior Compliance Analyst","External Examiner"];
const ACTIONS = ["View customer","Edit customer","Create case","Close case (maker)","Close case (checker)","File STR","Modify rule threshold","Approve threshold change","Admin access","Full read"];

export default function AccessControl() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/auth/users").then(r => setUsers(r.data.users || [])); }, []);
  return (
    <div>
      <PageHeader title="Access Control" subtitle="Role-based access · Permission matrix · Session log" sections={["5.9","5.11"]} />
      <div className="p-6 space-y-3">
        <Card>
          <CardHeader title="Users" subtitle="Seeded accounts for the evaluation environment" />
          <table className="dense w-full">
            <thead><tr><th>Name</th><th>Role</th><th>Email</th><th>MFA</th><th>Last login</th><th>Status</th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.email}><td className="text-[12px] font-medium">{u.name}</td><td className="text-[12px]">{u.role}</td><td className="text-[11px]">{u.email}</td><td><span className="text-[11px] px-1.5 py-0.5 bg-risk-low/15 text-risk-low rounded">TOTP</span></td><td className="text-[11px]">22 May 2026 09:14 WAT</td><td><StatusPill status="Active" /></td></tr>
              ))}
            </tbody>
          </table>
        </Card>
        <Card>
          <CardHeader title="Permission matrix" subtitle="Rows: actions · Columns: roles" />
          <div className="overflow-x-auto">
            <table className="dense w-full">
              <thead><tr><th>Action</th>{ROLES.map(r => <th key={r} className="text-center text-[10px]">{r.split(" ").map(w => w[0]).join("")}</th>)}</tr></thead>
              <tbody>
                {ACTIONS.map(a => (
                  <tr key={a}>
                    <td className="text-[12px]">{a}</td>
                    {ROLES.map(r => {
                      const allowed = !(a.includes("Admin") && !r.includes("Chief")) && !(a === "File STR" && !["MLRO","Chief Compliance Officer","Head of AML"].includes(r)) && !(a.includes("Modify rule") && ["External Examiner","KYC/CDD Manager","Senior Compliance Analyst"].includes(r));
                      return <td key={r} className="text-center">{allowed ? <span className="text-risk-low">●</span> : <span className="text-ink-subtle">○</span>}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  );
}
